import { css, keyframes } from 'styled-components';
var showPop = function showPop() {
  return keyframes(["0%{opacity:0;transform:scale(0.9);}50%{transform:scale(1);}"]);
};
export var showPopAnimation = css(["animation:", " 0.3s ease-in;"], showPop);